import React, { useEffect, useState } from "react";

import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
import { format } from "date-fns";

import { amountPrecision } from "constants/formConstants";

const companyName = process.env.REACT_APP_COMPANY_NAME;
const companyAddress = process.env.REACT_APP_COMPANY_ADDRESS;

const styles = StyleSheet.create({
	page: {
		flexDirection: "column",
		border: "none",
	},
	header: {
		backgroundColor: "#f9f9f9",
		width: "100vw",
		padding: "15px 0",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		border: "none",
	},
	headerText: {
		fontSize: "27pt",
	},
	headerSubText: {
		marginTop: "5pt",
		fontSize: "16pt",
		color: "#969696",
	},
	subHeader: {
		padding: "10px 5px 5px 5px",
		flexDirection: "row-reverse",
		fontSize: "15pt",
	},
	subHeaderDate: {
		flex: "0 0 300pt",
	},
	invoiceMeta: {
		padding: "3px 5px",
		flexDirection: "column",
		justifyContent: "space-between",
		color: "#666666",
		flexWrap: "wrap",
	},
	buyerName: {
		lineHeight: 1.44,
	},
	metaData: {
		textDecoration: "underline",
		color: "#111111",
	},
	metaTitle: {
		fontSize: "19pt",
		textTransform: "uppercase",
		textAlign: "center",
		margin: "0 0 15pt 0",
		letterSpacing: "3.5pt",
		padding: "3px",
	},
	tableHeader: {
		borderBottom: "1pt solid #969696",
		padding: 10,
		flexDirection: "row",
	},
	record: {
		padding: 10,
		flexDirection: "row",
	},
	particular: {
		width: "35vw",
	},
	qty: {
		maxWidth: "15vw",
		textAlign: "center",
	},
	rate: {
		maxWidth: "33vw",
		textAlign: "left",
	},
});

function EstimatePdf({ salesData }) {
	const [amount, setAmount] = useState(0);
	useEffect(() => {
		if (salesData?.data?.length) {
			const amts = [];
			for (const item of salesData.data)
				amts.push(parseFloat(item.quantity) * parseFloat(item.rate));
			console.log({ amts });
			if (amts.length)
				setAmount(
					amts
						.reduce((total, item) => total + item)
						.toFixed(amountPrecision)
				);
		}
	}, [salesData?.data]);
	return (
		<Document>
			<Page size="A5" style={styles.page}>
				<View style={styles.header}>
					<Text style={styles.headerText}>{companyName}</Text>
					<Text style={styles.headerSubText}>{companyAddress}</Text>
				</View>
				<View style={styles.subHeader}>
					<Text style={styles.subHeaderDate}>
						Date: {format(Date.now(), "dd-MM-yyyy")}
					</Text>
				</View>
				<View style={styles.invoiceMeta} wrap>
					<View>
						<Text style={styles.metaTitle}>estimate</Text>
					</View>
					<Text style={styles.buyerName}>
						Name:{" "}
						<Text style={styles.metaData}>
							{salesData.values?.buyer ?? "not specified"}
						</Text>
					</Text>
					<Text>
						Invoice No.:{" "}
						<Text style={styles.metaData}>
							{salesData.values?.invoiceNo ?? "not specified"}
						</Text>
					</Text>
				</View>
				<View style={styles.tableHeader}>
					<Text style={{ width: "40vw" }}>Particulars</Text>
					<Text style={{ width: "22vw", textAlign: "right" }}>
						Rate
					</Text>
					<Text style={{ width: "11vw", textAlign: "right" }}>
						Qty.
					</Text>
					<Text style={{ width: "23vw", textAlign: "right" }}>
						Amount
					</Text>
				</View>

				{/* data */}
				{salesData.data?.map((item) => (
					<ReceiptItemForEstimate
						name={item.name}
						quantity={item.quantity}
						rate={item.rate}
						key={item._id + item.quantity + item.rate}
					/>
				))}

				{/* footer */}
				<View
					style={{
						paddingTop: 5,
						paddingHorizontal: 10,
						borderTop: "1pt solid green",
						flexDirection: "column",
					}}
				>
					<View
						style={{
							width: "95vw",
							flexDirection: "row",
							justifyContent: "space-between",
						}}
					>
						<Text>Total</Text>
						<Text>{amount}/-</Text>
					</View>
					<View
						style={{
							width: "95vw",
							flexDirection: "row",
							justifyContent: "space-between",
						}}
					>
						<Text>Paid</Text>
						<Text>CASH</Text>
					</View>
				</View>
			</Page>
		</Document>
	);
}

const ReceiptItemForEstimate = ({ name, quantity, rate, ...rest }) => (
	<View
		{...rest}
		style={[styles.tableHeader, { fontSize: "14pt", borderBottom: "none" }]}
	>
		<View style={{ width: "40vw" }}>
			<Text>{name}</Text>
		</View>
		<Text style={[styles.rate, { width: "22vw", textAlign: "right" }]}>
			{rate}/-
		</Text>
		<Text style={{ width: "11vw", textAlign: "right" }}>{quantity}</Text>
		<Text style={{ width: "22vw", textAlign: "right" }}>
			{parseFloat(quantity) * parseFloat(rate)}/-
		</Text>
	</View>
);

export default EstimatePdf;
